"use client";

import React from "react";
import { Education } from "../components/Education";
import WorkExperience from "../components/WorkExperience";

export default function Experience() {
  return (
    <div className="relative bg-white dark:bg-gray-900 transition-colors duration-300">
      <Education />
      <WorkExperience />
    </div>
  );
}
